import { render, staticRenderFns } from "./DualInput.vue?vue&type=template&id=3dcff4d0&scoped=true&lang=pug&"
import script from "./DualInput.vue?vue&type=script&lang=js&"
export * from "./DualInput.vue?vue&type=script&lang=js&"
import style0 from "./DualInput.vue?vue&type=style&index=0&id=3dcff4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcff4d0",
  null
  
)

export default component.exports